export function isString(value: unknown) {
  return typeof value === "string";
}

export function isNumber(value: unknown) {
  return typeof value === "number";
}

export function isFunction(value: unknown) {
  return typeof value === "function";
}

export function isObject(value: unknown) {
  return typeof value === "object";
}

export function isArray(value: unknown) {
  return Array.isArray(value);
}

export function isUndefined(value: unknown): value is undefined {
  return typeof value === "undefined";
}

export function isNull(value: unknown): value is null {
  return typeof value === null;
}

export function sameValueZero(x: unknown, y: unknown) {
  if (typeof x === "number" && typeof y === "number") {
    // x and y are equal (may be -0 and 0) or they are both NaN
    return x === y || (x !== x && y !== y);
  }
  return x === y;
}

export function isError(value: unknown) {
  return isObject(value) && value instanceof Error;
}

export function isPromise(value: unknown) {
  return value instanceof Promise;
}

export function getTupleItem<T extends unknown[], I extends keyof T & number>(
  tuple: T,
  index: I,
): T[I] {
  return tuple[index];
}

export type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];
